'use client'

import { cn } from '@mntn-dev/ui-utilities'
import type { PropsWithChildren } from 'react'
import { getTestProps } from '../../../utils/testing.ts'
import { usePageHeaderContext } from './use-page-header.ts'

export const PageHeaderControls = ({
  children,
  className,
}: PropsWithChildren<{ className?: string }>) => {
  const { dataTestId, dataTrackingId } = usePageHeaderContext()
  return (
    <div
      className={cn('flex content-end items-center gap-6', className)}
      {...getTestProps({
        dataTestId: `${dataTestId}-controls`,
        dataTrackingId: `${dataTrackingId}-controls`,
      })}
    >
      {children}
    </div>
  )
}
